module.exports = __webpack_public_path__ + "img/qingsu-poster-level-5.8adfbb86.png";